import { render } from "./HermesThemeToggle.vue?vue&type=template&id=a65db866&scoped=true"
import script from "./HermesThemeToggle.vue?vue&type=script&lang=js"
export * from "./HermesThemeToggle.vue?vue&type=script&lang=js"

import "./HermesThemeToggle.vue?vue&type=style&index=0&id=a65db866&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a65db866"]])

export default __exports__